import { FileLink } from '@/components/portal/file-link';
import { useT } from '@/lib/i18n';
import type { InboxItem } from '@/lib/portal';
import { formatDateTime } from '@/lib/format';

/** The upload a bill or expense is being created from, beside the form (document inbox). */
export function InboxSource({ item }: { item: InboxItem }) {
  const t = useT();
  return (
    <div
      className="flex flex-wrap items-center gap-x-4 gap-y-1 rounded-md border border-primary/30 bg-primary/5 px-3 py-2 text-sm"
      data-testid="inbox-source"
    >
      <span className="font-medium">{t('files.fromInbox')}</span>
      <FileLink file={item.file} />
      <span className="text-muted-foreground">
        {t('files.uploadedBy', {
          kind: t(`inboxKind.${item.kind}`),
          who: item.uploadedBy ?? t('files.someone'),
          date: formatDateTime(item.uploadedAt),
        })}
        {item.note ? ` · “${item.note}”` : ''}
      </span>
      <span className="text-muted-foreground">{t('files.savingKeeps')}</span>
    </div>
  );
}
